/**
 * Browser polyfills for Node globals referenced by shared code.
 * Must load before any @koto-studio/shared modules that use global Buffer/process.
 */
import { Buffer } from 'buffer'

globalThis.Buffer = Buffer

if (typeof globalThis.process === 'undefined') {
  globalThis.process = {
    env: {},
    platform: 'linux',
    cwd: () => '/',
  } as typeof process
}
